import * as React from "react";

type CollectionSortingContextType = {
    isSorting: boolean;
    setIsSorting: React.Dispatch<React.SetStateAction<boolean>>;
};

const CollectionsSortingTracker = React.createContext<CollectionSortingContextType>({
    isSorting: false,
    setIsSorting: () => {}
});

const CollectionSortingContext: React.FunctionComponent<React.PropsWithChildren<{}>> = ({ children }) => {
    const [isSorting, setIsSorting] = React.useState(false);
    return <CollectionsSortingTracker.Provider value={{ isSorting, setIsSorting }}>{children}</CollectionsSortingTracker.Provider>;
};

function useCollectionSortingContext() {
    const context = React.useContext(CollectionsSortingTracker);
    return context;
}

export { CollectionSortingContext, useCollectionSortingContext };
